export var phoneMask = process.env.VM_MARKET === "SG" ? "9999 9999" : "9999 999 999";
export var applyPhoneMask = function applyPhoneMask(userPhoneNumber) {
  var phoneNumberArray = userPhoneNumber.split("");
  var maskedNumber = "";
  var userIndex = 0;
  for (var i = 0; i < phoneMask.length; i++) {
    if (phoneMask[i] === "9") {
      if (userIndex < phoneNumberArray.length) {
        maskedNumber += phoneNumberArray[userIndex];
        userIndex++;
      } else {
        break;
      }
    } else {
      maskedNumber += phoneMask[i];
    }
  }
  return maskedNumber;
};
var isSGMarket = process.env.VM_MARKET === "SG";

// Strip → repair → re-mask saved phones into the canonical form our
// inputs emit. `applyPhoneMask` slots every char into a digit position
// so already-formatted values double-space; saved addresses can arrive
// as raw digits, `+61 …`, hyphenated, etc. Recovers the two common
// shapes (country-coded prefix, missing leading 0) and warns on
// anything unrecoverable rather than silently mangling the data.
//
// Pass `{ quiet: true }` from display paths -- the warn is useful when
// we're explicitly correcting data (one-off assignment sites), but
// floods the console when re-evaluated on every render.
export var normalizePhoneNumber = function normalizePhoneNumber(phone, options) {
  if (!phone) return "";
  var digits = String(phone).replace(/\D/g, "");
  if (!digits) return "";
  var warn = function warn(msg) {
    if (!(options !== null && options !== void 0 && options.quiet)) {}
  };
  if (isSGMarket) {
    // SG mobiles: 8 digits, no leading 0. Recoverable shape is `65`-prefixed.
    if (digits.length === 10 && digits.startsWith("65")) {
      digits = digits.slice(2);
    } else if (digits.length !== 8) {
      warn("[normalizePhoneNumber] unrecognised SG phone shape:");
    }
  } else {
    // AU mobiles: 10 digits, leading 0. Recover `+61` and missing-leading-0.
    if (digits.length === 11 && digits.startsWith("61")) {
      digits = "0" + digits.slice(2);
    } else if (digits.length === 9 && !digits.startsWith("0")) {
      digits = "0" + digits;
    } else if (!(digits.length === 10 && digits.startsWith("0"))) {
      warn("[normalizePhoneNumber] unrecognised AU phone shape:");
    }
  }
  return applyPhoneMask(digits);
};
export var dateMask = [/[0-3]/, /\d/, "/", /[0-1]/, /\d/, "/", /[1-2]/, /\d/, /\d/, /\d/];
export var creditCardDateMask = [/[0-1]/, /\d/, "/", /[2]/, /\d/, /\d/, /\d/];
export var creditCardMask = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, " ", /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, " ", /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, " ", /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];